import { API_URL } from '../../../app-config/constants';
import { get } from '../request';

export function getAllNew() {
    return get(`${API_URL}/review/yourReviews`);
}
